import { FC } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { CheckListPopoverFilterSelector } from '@frontend/analytics-shared';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../../../../tracking-ids';
import { FilterIcon } from '../../atoms/filter-icon';
import { useSchedulingOutcomeFilterData } from './use-scheduling-outcome-filter-data';

export const SchedulingOutcomeFilterChip: FC<{ disabled?: boolean }> = ({ disabled }) => {
  const { t } = useTranslation('call-intelligence');
  const {
    value: selectedValues,
    defaultValue,
    schedulingOutcomeOptions,
    isLoading,
    onChange,
  } = useSchedulingOutcomeFilterData();

  const isDisabled = disabled || isLoading;

  return (
    <CheckListPopoverFilterSelector<CallIntelTypes.SchedulingOutcomeV2Enum>
      customStyles={{ chipDropdownFilter: { width: '100%' } }}
      defaultValue={defaultValue}
      label={t('Scheduling Outcome')}
      onChange={onChange}
      options={schedulingOutcomeOptions}
      renderIcon={(isFilterActive) => <FilterIcon name='calendar-small' isFilterActive={isFilterActive} />}
      trackingId={trackingIds.callIntel.schedulingOutcomesFilter}
      value={selectedValues}
      disabled={isDisabled}
    />
  );
};
